// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1gTWC","label":"LabeledBox_label__EUgiR"};